import {
  DeleteIcon,
  FormControlLabel,
  GKButton,
  GKSearchSelect,
  GKTextField,
  Grid2,
  IconButton,
  Paper,
  PlusIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "components";
import GKCheckbox from "components/GKCheckbox";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { handleReturnAutocompletePlaceholder } from "utils/StringFunctions";
import {
  FeeMethod,
  FeeType,
  PERFORMANCE_PLAN_FEE_PARAMETER,
} from "utils/constants";

const EditPerformanceFeePage = () => {
  const form = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "performanceFee.managementFeeSlab",
  });

  form.watch(["performanceFee.feeType"]);

  const isFeeTypeFix = form.getValues("performanceFee.feeType") !== "fixed";

  return (
    <Grid2 container spacing={1}>
      <Grid2 size={12}>
        <Typography fontSize={18} fontWeight={500}>
          Performance Fee
        </Typography>
      </Grid2>
      <Grid2 size={12} display={"flex"} gap={1}>
        <Controller
          name="performanceFee.minesManagementFee"
          control={form.control}
          render={({ field }) => (
            <FormControlLabel
              control={<GKCheckbox {...field} checked={field.value} />}
              label={"Management Fee Deduction"}
            />
          )}
        />
        <Controller
          name="performanceFee.highwatermark"
          control={form.control}
          render={({ field }) => (
            <FormControlLabel
              control={<GKCheckbox {...field} checked={field.value} />}
              label={"High Water Mark"}
            />
          )}
        />
        <Controller
          name="performanceFee.hardHurdle"
          control={form.control}
          defaultValue={false}
          render={({ field }) => (
            <FormControlLabel
              control={<GKCheckbox {...field} checked={field.value} />}
              label={"Hard Hurdle"}
            />
          )}
        />
        <Controller
          name="performanceFee.includeDividend"
          control={form.control}
          defaultValue={false}
          render={({ field }) => (
            <FormControlLabel
              control={<GKCheckbox {...field} checked={field.value} />}
              label={"Include Dividend"}
            />
          )}
        />
      </Grid2>

      <Grid2 size={6}>
        <Controller
          name="performanceFee.productName"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              placeholder={handleReturnAutocompletePlaceholder({
                placeholder: "Select Name",
                value: field.value,
              })}
              tooltipTitle="This name will appear on the invoices generated for your clients."
              inputLabel={"Product Name"}
            />
          )}
        />
      </Grid2>

      <Grid2 size={6}>
        <Controller
          name="performanceFee.hsnCode"
          control={form.control}
          rules={{
            required: {
              value: true,
              message: "Please enter HSN code",
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <GKTextField
              {...field}
              requiredField
              placeholder={handleReturnAutocompletePlaceholder({
                placeholder: "Select Code",
                value: field.value,
              })}
              inputLabel={"HSN Code"}
              tooltipTitle="This code will appear on invoices to classify your product for tax compliance."
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      </Grid2>
      <Grid2 size={4}>
        <Controller
          name="performanceFee.feeType"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              inputLabel="Fee Type"
              disableClearable={false}
              options={
                FeeType.filter((dataItem) => dataItem.value !== "fixed") || []
              }
              onChange={(e, val) => {
                field.onChange(val?.value);
              }}
              value={
                FeeType.find((dataItem) => dataItem.value === field.value) || ""
              }
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2>
      {isFeeTypeFix && (
        <>
          <Grid2 size={4}>
            <Controller
              name="performanceFee.feeMethod"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  inputLabel="Fee Method"
                  disableClearable={false}
                  options={FeeMethod || []}
                  onChange={(e, val) => field.onChange(val?.value)}
                  value={
                    FeeMethod.find(
                      (dataItem) => dataItem.value === field.value,
                    ) || ""
                  }
                  getOptionLabel={(option) => option.name || option}
                />
              )}
            />
          </Grid2>
          <Grid2 size={4}>
            <Controller
              name="performanceFee.calculationBenchmark"
              control={form.control}
              render={({ field }) => (
                <GKSearchSelect
                  inputLabel="Fee Parameter"
                  disableClearable={false}
                  options={PERFORMANCE_PLAN_FEE_PARAMETER}
                  onChange={(e, val) => field.onChange(val?.value)}
                  value={
                    PERFORMANCE_PLAN_FEE_PARAMETER.find(
                      (dataItem) => dataItem.value === field.value,
                    ) || ""
                  }
                  getOptionLabel={(option) => option.name || option}
                />
              )}
            />
          </Grid2>
        </>
      )}

      {/* <Grid2 size={4}>
        <Controller
          name="performanceFee.calculationFrequency"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              inputLabel="Calculation Frequency"
              disableClearable={false}
              options={calculationFrequency || []}
              onChange={(e, val) => field.onChange(val.value)}
              value={
                calculationFrequency.find(
                  (dataItem) => dataItem.value === field.value
                ) || ""
              }
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2> */}
      <Grid2 size={4}>
        <Controller
          name="performanceFee.fee"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              inputLabel={!isFeeTypeFix ? "Fee Amount" : "Fee %"}
              type="number"
            />
          )}
        />
      </Grid2>
      {/* <Grid2 size={4}>
        <Controller
          name="performanceFee.billFrequency"
          control={form.control}
          render={({ field }) => (
            <GKSearchSelect
              inputLabel="Billing Frequency"
              disableClearable={false}
              options={billingFrequency || []}
              onChange={(e, val) => field.onChange(val.value)}
              value={
                billingFrequency.find(
                  (dataItem) => dataItem.value === field.value
                ) || ""
              }
              getOptionLabel={(option) => option.name || option}
            />
          )}
        />
      </Grid2> */}
      <Grid2 size={4}>
        <Controller
          name="performanceFee.outOfPocketExpenses"
          control={form.control}
          render={({ field }) => (
            <GKTextField
              {...field}
              inputLabel="Out Of Pocket Expense"
              name="performanceFee.outOfPocketExpenses"
              type="number"
            />
          )}
        />
      </Grid2>
      {/* <Grid2 size={4}>

          <Controller
            name="performanceFee.minimumFee"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Minimum Fee"
                name="performanceFee.minimumFee"
                type="number"
              />
            )}
          />

      </Grid2>
      <Grid2 size={4}>

          <Controller
            name="performanceFee.maximumFee"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Maximum Fee"
                name="performanceFee.maximumFee"
                type="number"
              />
            )}
          />

      </Grid2> */}
      {/* <Grid2 size={4}>

          <Controller
            name="performanceFee.softHurdle"
            control={form.control}
            render={({ field }) => (
              <GKTextField
                {...field}
                inputLabel="Soft Hurdle"
                name="performanceFee.softHurdle"
                type="number"
              />
            )}
          />

      </Grid2> */}
      {form.watch("performanceFee.hardHurdle") && (
        <Grid2 size={4}>
          <Controller
            name="performanceFee.hurdle"
            control={form.control}
            render={({ field }) => (
              <GKTextField {...field} inputLabel="Hurdle" type="number" />
            )}
          />
        </Grid2>
      )}

      {/* {isFeeTypeFix && (
        <Grid2 size={4}>
          <Controller
            name="performanceFee.calculationMethod"
            control={form.control}
            render={({ field }) => (
              <GKSearchSelect
                {...field}
                inputLabel="Calculation Method"
                disableClearable={false}
                options={
                  managementFeeCalculationMethod.filter(
                    (dataItem) => dataItem.value !== "advance"
                  ) || []
                }
                onChange={(e, val) => field.onChange(val.value)}
                value={
                  managementFeeCalculationMethod.find(
                    (dataItem) => dataItem.value === field.value
                  ) || ""
                }
                getOptionLabel={(option) => option.name || option}
              />
            )}
          />
        </Grid2>
      )} */}

      {/* {form.getValues("managementFee.highwatermark") && (
        <Grid2 size={4}>

            <Controller
              name="performanceFee.highwatermarkAmount"
              control={form.control}
              render={({ field }) => (
                <GKTextField
                  {...field}
                  inputLabel="High Water Mark Amount"
                  name="performanceFee.highwatermarkAmount"
                  type="number"
                />
              )}
            />

        </Grid2>
      )} */}

      {form.getValues("performanceFee.feeMethod") === "slabs" && (
        <Grid2 size={12}>
          <TableContainer
            component={Paper}
            sx={{ marginTop: 2, minHeight: 100 }}
          >
            <Table
              sx={{ minWidth: 500 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    colSpan={2}
                    style={{
                      padding: 12,
                    }}
                  >
                    <Typography
                      fontSize={16}
                      fontWeight={700}
                      color={"var(--primary-900)"}
                    >
                      Slabs
                    </Typography>
                  </TableCell>
                  <TableCell
                    colSpan={2}
                    align="right"
                    style={{
                      padding: 12,
                    }}
                  >
                    <Typography
                      fontSize={16}
                      fontWeight={700}
                      color={"var(--primary-900)"}
                    >
                      <GKButton
                        variant="outlined"
                        onClick={() => {
                          append({
                            lowerLimit: "",
                            upperLimit: "",
                            slabFee: "",
                          });
                        }}
                        startIcon={<PlusIcon />}
                      >
                        Add Slab
                      </GKButton>
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  <TableCell>From</TableCell>
                  <TableCell>To</TableCell>
                  <TableCell>Management Fee&nbsp;(%)</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {fields.map((row: any, index: number) => {
                  return (
                    <TableRow
                      key={row.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        <Controller
                          name={`performanceFee.managementFeeSlab[${index}].lowerLimit`}
                          control={form.control}
                          render={({ field }) => (
                            <GKTextField
                              {...field}
                              name={`performanceFee.managementFeeSlab[${index}].lowerLimit`}
                              type="number"
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Controller
                          name={`performanceFee.managementFeeSlab[${index}].upperLimit`}
                          control={form.control}
                          render={({ field }) => (
                            <GKTextField
                              {...field}
                              name={`performanceFee.managementFeeSlab[${index}].upperLimit`}
                              type="number"
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Controller
                          name={`performanceFee.managementFeeSlab[${index}].slabFee`}
                          control={form.control}
                          render={({ field }) => (
                            <GKTextField
                              {...field}
                              name={`performanceFee.managementFeeSlab[${index}].slabFee`}
                              type="number"
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          color="error"
                          className="outline"
                          disabled={fields.length === 1}
                          onClick={() => remove(index)}
                        >
                          <DeleteIcon width={16} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
      )}
    </Grid2>
  );
};

export default EditPerformanceFeePage;
